import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FIELDS = [
  ["immobili", "Immobili gestiti"],
  ["contratti", "Contratti di affitto gestiti"],
  ["proprietari", "Proprietari che hanno scelto Semplificaffitto.it"],
];

export default function StatsSettings() {
  const [stats, setStats] = useState({ immobili: 57, contratti: 102, proprietari: 56 });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/settings/stats`)
      .then(({ data }) =>
        setStats({
          immobili: data.immobili ?? 57,
          contratti: data.contratti ?? 102,
          proprietari: data.proprietari ?? 56,
        })
      )
      .catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const token = localStorage.getItem("sf-admin-token") || "";
      await axios.put(`${API}/admin/settings/stats`, stats, { headers: { Authorization: `Bearer ${token}` } });
      toast.success("Contatori aggiornati: la home mostra già i nuovi numeri");
    } catch {
      toast.error("Errore nel salvataggio dei contatori");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white rounded-2xl border border-ink/10 p-6 mb-10" data-testid="admin-stats-settings">
      <h2 className="font-serif font-bold text-xl mb-1">I numeri in home</h2>
      <p className="text-xs text-ink/50 mb-5">I tre contatori della home si aggiornano da qui, in tempo reale.</p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {FIELDS.map(([key, label]) => (
          <label key={key} className="block">
            <span className="block text-xs font-semibold text-ink/50 uppercase tracking-wider mb-1.5">{label}</span>
            <input
              type="number"
              min="0"
              value={stats[key]}
              onChange={(e) => setStats((s) => ({ ...s, [key]: Number(e.target.value) }))}
              data-testid={`admin-stat-input-${key}`}
              className="w-full rounded-xl bg-white border border-ink/15 px-4 py-3 text-lg font-serif font-bold text-brandblue focus:outline-none focus:border-azure"
            />
          </label>
        ))}
      </div>
      <button
        onClick={save}
        disabled={saving}
        data-testid="admin-stats-save-btn"
        className="mt-5 inline-flex items-center gap-2 bg-ink text-white text-sm font-semibold rounded-full px-6 py-3 hover:bg-brandblue disabled:opacity-60 transition-colors"
      >
        {saving ? <Loader2 size={15} className="animate-spin" /> : <Save size={15} />}
        Salva contatori
      </button>
    </div>
  );
}
